export default class AlLoaderController {

    constructor($scope, $injector, $element) {
        this.scope = $scope;
        this.injector = $injector;
        this.element = $element;

        this.size = 'small';
    }
}

AlLoaderController.$inject = [
    '$scope',
    '$injector',
    '$element'
];



// WEBPACK FOOTER //
// ./src/app/modules/core/components/al-loader/controller.js